import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import AnimatedBackground from '../AnimatedBackground/AnimatedBackground';
import './Industries.css';

const Industries = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const industries = [
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind1)" opacity="0.15"/>
          <path d="M20 50 L30 40 L30 30 L40 30 L40 20 L50 30 L60 30 L60 55 L20 55 Z" fill="#0071e3" opacity="0.8"/>
          <rect x="25" y="45" width="8" height="10" fill="#fff" opacity="0.6"/>
          <rect x="36" y="40" width="8" height="15" fill="#fff" opacity="0.6"/>
          <rect x="47" y="35" width="8" height="20" fill="#fff" opacity="0.6"/>
          <defs>
            <linearGradient id="ind1" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#0071e3"/>
              <stop offset="100%" stopColor="#bf5af2"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Manufacturing',
      description: 'Smart factory solutions, production line automation, and quality control systems',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind2)" opacity="0.15"/>
          <circle cx="40" cy="30" r="8" fill="#30d158"/>
          <path d="M32 38 L48 38 L50 50 L30 50 Z" fill="#0071e3" opacity="0.8"/>
          <rect x="25" y="50" width="30" height="8" fill="#bf5af2" opacity="0.8"/>
          <defs>
            <linearGradient id="ind2" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#30d158"/>
              <stop offset="100%" stopColor="#0071e3"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Energy & Utilities',
      description: 'Power plant automation, renewable energy systems, and grid management',
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind3)" opacity="0.15"/>
          <path d="M40 20 L50 35 L45 35 L48 50 L32 35 L37 35 L40 20 Z" fill="#bf5af2"/>
          <circle cx="25" cy="50" r="6" fill="#0071e3" opacity="0.7"/>
          <circle cx="55" cy="50" r="6" fill="#30d158" opacity="0.7"/>
          <defs>
            <linearGradient id="ind3" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#bf5af2"/>
              <stop offset="100%" stopColor="#0071e3"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Pharmaceuticals',
      description: 'GMP-compliant automation, batch processing, and regulatory compliance systems',
      image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind4)" opacity="0.15"/>
          <rect x="20" y="30" width="40" height="20" rx="3" fill="#0071e3" opacity="0.8"/>
          <circle cx="30" cy="50" r="8" stroke="#bf5af2" strokeWidth="3" fill="none"/>
          <circle cx="50" cy="50" r="8" stroke="#bf5af2" strokeWidth="3" fill="none"/>
          <rect x="35" y="25" width="10" height="8" fill="#30d158"/>
          <defs>
            <linearGradient id="ind4" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#0071e3"/>
              <stop offset="100%" stopColor="#30d158"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Automotive',
      description: 'Assembly line automation, robotic welding, and inspection systems',
      image: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind5)" opacity="0.15"/>
          <rect x="25" y="25" width="30" height="30" rx="5" fill="#30d158" opacity="0.8"/>
          <circle cx="40" cy="40" r="8" fill="#fff"/>
          <path d="M40 32 L40 48 M32 40 L48 40" stroke="#0071e3" strokeWidth="3"/>
          <defs>
            <linearGradient id="ind5" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#30d158"/>
              <stop offset="100%" stopColor="#bf5af2"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Food & Beverage',
      description: 'Processing automation, packaging systems, and food safety compliance',
      image: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind6)" opacity="0.15"/>
          <rect x="25" y="25" width="15" height="15" fill="#0071e3" opacity="0.8"/>
          <rect x="45" y="25" width="15" height="15" fill="#bf5af2" opacity="0.8"/>
          <rect x="25" y="45" width="15" height="15" fill="#30d158" opacity="0.8"/>
          <rect x="45" y="45" width="15" height="15" fill="#0071e3" opacity="0.8"/>
          <defs>
            <linearGradient id="ind6" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#bf5af2"/>
              <stop offset="100%" stopColor="#0071e3"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Logistics',
      description: 'Warehouse automation, inventory management, and material handling systems',
      image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind7)" opacity="0.15"/>
          <circle cx="40" cy="35" r="12" fill="#bf5af2" opacity="0.3"/>
          <circle cx="30" cy="48" r="8" fill="#0071e3" opacity="0.6"/>
          <circle cx="50" cy="48" r="8" fill="#30d158" opacity="0.6"/>
          <path d="M40 45 L40 55" stroke="#0071e3" strokeWidth="2"/>
          <defs>
            <linearGradient id="ind7" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#0071e3"/>
              <stop offset="100%" stopColor="#bf5af2"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Chemical Processing',
      description: 'Process control, safety systems, and batch management solutions',
      image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=500&h=350&fit=crop'
    },
    {
      icon: (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="40" r="38" fill="url(#ind8)" opacity="0.15"/>
          <rect x="25" y="30" width="30" height="20" rx="2" fill="#0071e3" opacity="0.8"/>
          <rect x="29" y="34" width="6" height="4" fill="#30d158"/>
          <rect x="37" y="34" width="6" height="4" fill="#30d158"/>
          <rect x="45" y="34" width="6" height="4" fill="#30d158"/>
          <rect x="29" y="42" width="6" height="4" fill="#bf5af2"/>
          <rect x="37" y="42" width="6" height="4" fill="#bf5af2"/>
          <rect x="45" y="42" width="6" height="4" fill="#bf5af2"/>
          <defs>
            <linearGradient id="ind8" x1="0" y1="0" x2="80" y2="80">
              <stop offset="0%" stopColor="#30d158"/>
              <stop offset="100%" stopColor="#0071e3"/>
            </linearGradient>
          </defs>
        </svg>
      ),
      name: 'Electronics',
      description: 'PCB assembly automation, testing systems, and quality inspection',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=500&h=350&fit=crop'
    }
  ];

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: [0.25, 0.4, 0.25, 1],
      },
    }),
  };

  return (
    <section id="industries" className="industries" ref={ref}>
      <AnimatedBackground variant="industries" />
      <div className="container">
        <div className="industries-content-wrapper">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="section-title">Industries We Serve</h2>
            <p className="section-subtitle">
              Delivering specialized solutions across diverse industrial sectors
            </p>
          </motion.div>

          <div className="industries-grid">
            {industries.map((industry, index) => (
              <motion.div
                key={index}
                className="industry-card"
                custom={index}
                initial="hidden"
                animate={inView ? 'visible' : 'hidden'}
                variants={cardVariants}
                whileHover={{ scale: 1.05 }}
              >
                <div className="industry-image-wrapper">
                  <img 
                    src={industry.image} 
                    alt={industry.name}
                    className="industry-image"
                  />
                </div>
                <h3 className="industry-name">{industry.name}</h3>
                <p className="industry-description">{industry.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
